export default __webpack_public_path__ + "static/media/alexandre.201e6919.jpg";